import {
  DefaultApi as AuthClient,
  Configuration,
} from '@peartherapeutics/auth-service-client';
import { getConfig } from 'utils/config';

export default async function getAuthClient(): Promise<AuthClient> {
  const { AUTH_URL } = await getConfig();
  return new AuthClient(new Configuration({ basePath: AUTH_URL }));
}
